// extracted by mini-css-extract-plugin
export default {"floatingButton":"styles-module__floatingButton__src-labstep-web-components-Protocol-Form-ShowEdit-State-_XsW2L"};